"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M22.179 5.708a12.29 12.29 0 0 1 2.042 24.408s-1.646.176-2.989.176h-9.38a10.407 10.407 0 0 1-.006-20.813 10.8 10.8 0 0 1 1.362.086l.581-.544a12.239 12.239 0 0 1 8.39-3.313zm0-1.308A13.541 13.541 0 0 0 12.9 8.066l-.148.138c-.3-.022-.6-.033-.9-.033a11.714 11.714 0 0 0-.001 23.429h9.38c1.4 0 3.059-.176 3.128-.184A13.6 13.6 0 0 0 22.179 4.4z" }),
  React.createElement("path", { d: "M15.495 10.9a9.567 9.567 0 0 1 1.677.869 7.961 7.961 0 1 1-.672 11.853l-4.652-4.666a.878.878 0 1 0-1.257 1.224l4.675 4.69a9.717 9.717 0 1 0 .229-13.97zM4.068 19.866a7.855 7.855 0 0 0 7.858 7.854h4.1a11.5 11.5 0 0 1-2.16-1.75h-1.94a6.1 6.1 0 0 1 0-12.209 5.815 5.815 0 0 1 4 1.5l3.535 3.627a.877.877 0 1 0 1.257-1.225l-3.532-3.633a7.6 7.6 0 0 0-5.266-2.024 7.851 7.851 0 0 0-7.853 7.854z" })
);

